<template>
    <!-- Sales Forecast List View -->
    <div class="page-layout blank contacts-manage">
        <div style="padding-bottom:8rem">
            <div class="breadcrumbnew">
                <span>Sales </span>
                <span>Sales Forecasting</span>
                <router-link to="/listsalesforecast">List View</router-link>
            </div>
            <div class="design-block pl-15 pr-15 py-5">
                <h2 class="headerblock">
                    <div class="d-flex flex-wrap justify-content-between">
                        <div class="">
                            <router-link :disabled="!$routerHistory.hasPrevious()"
                                :to="{ path: $routerHistory.previous().path }">
                                <el-tooltip class="item pull-left" effect="dark" content="Click to Go Back"
                                    placement="top">
                                    <button class="router mr-3 mt-2 pointer">
                                        <i class="icons icon-arrow-left text-white"></i>
                                    </button>
                                </el-tooltip>
                            </router-link>
                            <router-link :disabled="!$routerHistory.hasForward()"
                                :to="{ path: $routerHistory.next().path }">
                                <el-tooltip class="item pull-left" effect="dark" content="Click to Go Forward"
                                    placement="top">
                                    <button class="router mr-3 mt-2 pointer">
                                        <i class="icons icon-arrow-right text-white"></i>
                                    </button>
                                </el-tooltip>
                            </router-link>
                            <a href="javascript:;" v-if="deleteIds.length"
                                class="btn btn-new-disabled btn-xlg text-white mr-1 mt-2" style="border-radius:4px">
                                + Create
                            </a>
                            <a href="javascript:;" v-on:click="createSaleForecast()" v-else
                                class="btn btn-new-primary btn-xlg mr-1 mt-2" style="border-radius:4px;">
                                + Create
                            </a>
                            <span v-if="deleteIds.length">
                                <a v-if="activeSave" href="javascript:;" class="btn btn-new-warning btn-xlg mr-1 mt-2"
                                    style="border-radius:4px" @click="editsales()">
                                    <i class="icon-pencil iconsize-16 mr-1"></i> Edit
                                </a>
                                <a v-if="activeSave == false" href="javascript:;"
                                    class="btn btn-new-warning btn-xlg mr-1 mt-2" style="border-radius:4px"
                                    @click="save()">
                                    <i class="icon iconsize-16 mr-1"></i> Save
                                </a>
                                <a v-if="activeSave == false" href="javascript:;"
                                    class="btn btn-new-darkdanger text-white btn-xlg mr-1 mt-2" style="border-radius:4px"
                                    @click="cancel()">
                                    <i class="icon-close iconsize-16 mr-1"></i> Cancel
                                </a>
                                <a v-if="activeSave" href="javascript:;"
                                    class="btn btn-new-darkdanger btn-xlg mr-1 mt-2" style="border-radius:4px"
                                    @click="deleteSales()">
                                    <i class="icon-trash iconsize-16 mr-1"></i> Delete
                                </a>
                                <a v-if="activeSave == false" href="javascript:;"
                                    class="btn btn-new-disabled btn-xlg mr-1 mt-2" style="border-radius:4px">
                                    <i class="icon-trash iconsize-16 mr-1"></i> Delete
                                </a>
                            </span>
                            <span v-else>
                                <a href="javascript:;" class="btn btn-new-disabled btn-xlg mr-1 mt-2"
                                    style="border-radius:4px">
                                    <i class="icon-pencil iconsize-16 mr-1"></i> Edit
                                </a>
                                <a href="javascript:;" class="btn btn-new-disabled btn-xlg mr-1 mt-2"
                                    style="border-radius:4px">
                                    <i class="icon-trash iconsize-16 mr-1"></i> Delete
                                </a>
                            </span>
                            <!-- <span v-if="showEditDelete && deleteIds.length">
                                <a href="javascript:;" style="border-radius:4px" class="btn btn-new-darkdanger btn-xlg mr-1"
                                    @click="cancel()">Cancel</a>
                                <a href="javascript:;" style="border-radius:4px" class="btn btn-new-darksuccess text-white btn-xlg mr-1"
                                    @click="save()">Save</a>
                            </span> -->
                            <span class="align-middle font-weight-bold px-5"
                                style="font-size: 14px;position:relative;top:4px">
                                Quantity OFF
                                <el-switch class="routers light-blue_el ml-4" v-model="quantityOnOff"
                                    active-color="#005dae" inactive-color="#f0f0f0"></el-switch>
                            </span>
                        </div>
                        <div class="">
                            <!-- <div class="d-none d-xl-inline"> -->
                            <div class="d-flex flex-column pull-right pr-2">
                                <div class="d-flex justify-content-end">
                                    <div>
                                        <el-dropdown @click="handleClick" trigger="click">
                                            <span class="btn btn-new-darksuccess btn-xlg mr-1 mt-2">
                                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/exports.svg" />
                                                <span
                                                    class="text-white font-weight-bold ml-1 hidden-sm-down">Export</span>
                                            </span>
                                            <el-dropdown-menu slot="dropdown">
                                                <el-dropdown-item>PDF</el-dropdown-item>
                                                <el-dropdown-item>XLSX</el-dropdown-item>
                                                <el-dropdown-item>CSV</el-dropdown-item>
                                            </el-dropdown-menu>
                                        </el-dropdown>
                                    </div>
                                    <button class="btn btn-new-primary btn-xlg mr-1 mt-2" @click="print('printId')">
                                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/printer.svg" />
                                        <span class="text-white font-weight-bold ml-1 hidden-sm-down">Print</span>
                                    </button>
                                    <button class="btn btn-new-darkdanger btn-xlg mr-1 mt-2">
                                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/pdf-file.svg" />
                                        <span class="text-white font-weight-bold ml-1 hidden-sm-down">Pdf</span>
                                    </button>
                                    <div class="pagination-footer d-flex align-items-center" style="margin-top: 10px;">
                                        <button type="button" class="btn btn-icon" id="previous"
                                            style="padding: 4px 1.8px 0.8rem 2px;" @click="previousPage()">
                                            <el-tooltip class="item" effect="dark" content="Previous" placement="top">
                                                <i class="icon icon-chevron-left"
                                                    style="color: #4e5764 !important;"></i>
                                            </el-tooltip>
                                        </button>
                                        <button type="button" class="btn btn-icon" id="next"
                                            style="padding-left:1.8px;padding-top: 4px;" @click="nextPage()">
                                            <el-tooltip class="item" effect="dark" content="Next" placement="top">
                                                <i class="icon icon-chevron-right"
                                                    style="color: #4e5764 !important;"></i>
                                            </el-tooltip>
                                        </button>
                                    </div>
                                    <div>
                                        <span class="float-right page-info px-2 pt-2 fw-600 mt-2"
                                            style="color: #4e5764;font-size: 14px;">Page {{getSkipCount}} - {{totalSaleForecast>skip+limit?skip+limit:totalSaleForecast}} of {{totalSaleForecast}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </h2>
                <div class="row headerblock" style="padding: 0 1rem 1rem 1rem !important;">
                    <div class="col-lg-3 col-md-6 col-sm-6 responsiveHeader mt-2 px-6">
                        <label for="staticEmail2" class="text-black fs-14 whiteSpace vselectLabel fw-600"
                            style="width: 34vw">Company Name (Customer) <sup v-if="activeSalesView == true" class="fs-14 ml-02 mandatory">*</sup></label>
                        <!-- <div class="d-flex flex-column" style="width:100%" v-if="activeSalesView == true">
                            <multiselect v-validate="'required'" :max-height="250"
                                class="digi-multiselect loaderbgwhite" @open="fetchCustomers"
                                @search-change="fetchCustomers" @close="updateBranch(selectCompany);search_key = ''"
                                @select="clearData" :loading="isLoading" v-model="selectCompany" :searchable="true"
                                placeholder="Ex. Cocacola" label="company_name" track-by="_id" :options="customers"
                                :multiple="false" :taggable="false" :close-on-select="true" :show-labels="false"
                                :clear-on-select="false" :hide-selected="false" name="companies">
                                <template slot="tag" slot-scope="{ option, remove }">
                                    <span class="custom__tag">
                                        <span>{{ option.company_name }}</span>
                                        <span class="custom__remove" @click="remove(option)">
                                            <i class="icon-close iconsize-16 defaultDarkBlue"></i>
                                        </span>
                                    </span>
                                </template>
                                <template slot="afterList">
                                    <div v-observe-visibility="reachedEndOfListCustomer" />
                                </template>
                                <template slot="noOptions">
                                    <div class="text-secondary text-center fw-600">List is Empty</div>
                                </template>
                                <template slot="noResult">
                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                </template>
                            </multiselect>
                            <span class="invalid-feedback-form text-danger"
                                style="text-transform: none !important;margin-top: 2px;"
                                v-show="errors.has('companies')">Customer Name is Required</span>
                        </div> -->
                        <div class="view-sales-list">{{selectCompany.company_name || '-'}}</div>
                        <!-- <div>{{selectCompany}}</div> -->
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6 responsiveHeader mt-2 px-6">
                        <label for="staticEmail2" class="text-black fs-14 whiteSpace vselectLabel fw-600"
                            style="width: 34vw">Branch Name <sup v-if="activeSalesView == true" class="fs-14 ml-02 mandatory">*</sup></label>
                        <!-- <div class="d-flex flex-column" style="width:100%" v-if="activeSalesView == true">
                            <multiselect @close="updateDept(branchName)"
                                @select="documentTypeSelectedInside = true,getListSalesForecast()" label="name"
                                track-by="_id" v-validate="'required'" :max-height="250"
                                class="digi-multiselect loaderbgwhite" v-model="branchName" :block-keys="['Tab']"
                                :searchable="true" placeholder="Ex. Sales" :options="branchs" :multiple="false"
                                :taggable="false" :close-on-select="true" :show-labels="false" :clear-on-select="false"
                                :hide-selected="false" name="branches">
                                <template slot="noOptions">
                                    <div class="text-secondary text-center fw-600">List is Empty</div>
                                </template>
                                <template slot="noResult">
                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                </template>
                            </multiselect>
                            <span class="invalid-feedback-form text-danger"
                                style="text-transform: none !important;margin-top: 2px;"
                                v-show="errors.has('branches')">Branch Name is Required</span>
                        </div> -->
                        <div class="view-sales-list">{{branchName.name || '-'}}</div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6 responsiveHeader mt-2 px-6">
                        <label for="staticEmail2" class="text-black fs-14 whiteSpace vselectLabel fw-600"
                            style="width: 34vw">Department Name <sup v-if="activeSalesView == true" class="fs-14 ml-02 mandatory">*</sup></label>
                        <!-- <div class="d-flex flex-column" style="width:100%" v-if="activeSalesView == true">
                            <multiselect v-validate="'required'" :max-height="250"
                                class="digi-multiselect loaderbgwhite" v-model="departmentName" :block-keys="['Tab']"
                                :searchable="true" placeholder="Ex. Sales and Marketing" :options="departments"
                                @select="documentTypeSelectedInside = true,getListSalesForecast()" :multiple="false"
                                :taggable="false" :close-on-select="true" :show-labels="false" :clear-on-select="false"
                                :hide-selected="false" name="dept">
                                <template slot="noOptions">
                                    <div class="text-secondary text-center fw-600">List is Empty</div>
                                </template>
                                <template slot="noResult">
                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                </template>
                            </multiselect>
                            <span class="invalid-feedback-form text-danger"
                                style="text-transform: none !important;margin-top: 2px;"
                                v-show="errors.has('dept')">Department Name is Required</span>
                        </div> -->
                        <div class="view-sales-list">{{departmentName || '-'}}</div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6 responsiveHeader mt-2 px-6">
                        <label for="staticEmail2" class="text-black fs-14 whiteSpace vselectLabel fw-600"
                            style="width: 34vw">
                            Fiscal Year
                            <el-tooltip class="item" effect="dark" content="Fiscal Year" placement="top">
                                <i class="icon-information text-secondary iconsize-18 ml-3"></i>
                            </el-tooltip>
                        </label>
                        <!-- <div class="d-flex flex-column" style="width:100%" v-if="activeSalesView == true">
                            <el-dropdown trigger="click" :hide-on-click="hide_el_dropdown"
                                @visible-change="dropdownTriggered"
                                style="border-bottom: 1px solid #a9aaad; line-height: 33px;">
                                <span class="mr-1"
                                    style="font-weight: 600; color: #303031; width: 100%; display: block">
                                    <span>{{target_year}}</span>
                                </span>
                                <el-dropdown-menu slot="dropdown" class="fiscal-year-el">
                                    <el-dropdown-item class="d-flex justify-content-between align-items-center">
                                        <i class="icon-chevron-double-left m-0" @click="yearPrev"></i>
                                        <span style="font-size: 12px; font-weight: 400">{{years_to_set[0]}} -
                                            {{years_to_set[5]}}</span>
                                        <i class="icon-chevron-double-right m-0" @click="yearNext"></i>
                                    </el-dropdown-item>
                                    <el-dropdown-item
                                        class="d-flex flex-column justify-content-center align-items-center">
                                        <span
                                            :class="{ 'selectedYear':target_year_selected == `${years_to_set[0]}-${years_to_set[1]}` }"
                                            @click="yearClicked(years_to_set[0], years_to_set[1])">{{years_to_set[0]}} -
                                            {{years_to_set[1]}}</span>
                                        <span
                                            :class="{ 'selectedYear':target_year_selected == `${years_to_set[1]}-${years_to_set[2]}` }"
                                            @click="yearClicked(years_to_set[1], years_to_set[2])">{{years_to_set[1]}} -
                                            {{years_to_set[2]}}</span>
                                        <span
                                            :class="{ 'selectedYear':target_year_selected == `${years_to_set[2]}-${years_to_set[3]}` }"
                                            @click="yearClicked(years_to_set[2], years_to_set[3])">{{years_to_set[2]}} -
                                            {{years_to_set[3]}}</span>
                                        <span
                                            :class="{ 'selectedYear':target_year_selected == `${years_to_set[3]}-${years_to_set[4]}` }"
                                            @click="yearClicked(years_to_set[3], years_to_set[4])">{{years_to_set[3]}} -
                                            {{years_to_set[4]}}</span>
                                        <span
                                            :class="{ 'selectedYear':target_year_selected == `${years_to_set[4]}-${years_to_set[5]}` }"
                                            @click="yearClicked(years_to_set[4], years_to_set[5])">{{years_to_set[4]}} -
                                            {{years_to_set[5]}}</span>
                                        <a href="javascript:;" class="btn btn-new-primary btn-xsm mt-2 mb-4"
                                            @click="documentTypeSelectedInside = true,getFilteredListData()">Apply</a>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div> -->
                        <div class="view-sales-list">{{target_year || '-'}}</div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6 responsiveHeader mt-2 px-6">
                        <label for="staticEmail2" class="text-black fs-14 whiteSpace vselectLabel fw-600"
                            style="width: 34vw">Main Sales Person</label>
                        <!-- <div class="d-flex flex-column" style="width:100%" v-if="activeSalesView == true">
                            <multiselect :max-height="250" class="digi-multiselect loaderbgwhite"
                                @open="fetchSalesPerson" @search-change="fetchSalesPerson" @close="search_key = ''"
                                :loading="loadSalesPerson" v-model="mainSalesPerson" :searchable="true"
                                placeholder="Select Main Sales Person" label="full_name" track-by="_id"
                                :options="salesperson" :multiple="false" :taggable="false" :close-on-select="true"
                                :show-labels="false" :clear-on-select="false" :hide-selected="false">
                                <template slot="noOptions">
                                    <div class="text-secondary text-center fw-600">List is Empty</div>
                                </template>
                                <template slot="noResult">
                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                </template>
                            </multiselect>
                        </div> -->
                        <div class="view-sales-list">{{mainSalesPerson.full_name || '-'}}</div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-6 responsiveHeader mt-10 px-6">
                        <div style="width:100%">
                            <multiselect v-validate="'required'" :max-height="250"
                                class="digi-multiselect loaderbgwhite" label="name" track-by="name" index="id"
                                placeholder="Select" :clearable="false" name="forecast"
                                @select="documentTypeSelectedInside = true,document_type.id == 'forecast' ? getListSalesForecast() : getDataToView()"
                                :multiple="false" :taggable="false" :close-on-select="true" :show-labels="false"
                                :clear-on-select="false" :hide-selected="false" v-model="document_type"
                                :options="dType"></multiselect>
                        </div>
                    </div>
                    <div class="col-lg-2 col-md-3 col-sm-3 respomsiveHeader mt-10">
                        <a href="javascript:;" @click="openFilters()" class="btn btn-secondary btn-smm text-white"
                            style="padding: 0 7px !important; border-radius: 10px !important">
                            <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/filter_icon.svg" alt="filter" style="margin-right: 8px;" />Filter
                        </a>
                    </div>
                    <div class="col-lg-4 col-md-9 col-sm-9 respomsiveHeader mt-10">
                        <span class="fw-500 fs-15">
                            <span style="color: #005dae">Sales Forecast ID : </span><span
                                style="color: #000">{{sales_number_id || '-'}}</span>
                        </span>
                    </div>
                </div>
                <div class="filterblock" v-if="filterblock">
                    <div class="d-flex flex-row justify-content-between">
                        <div class="d-flex flex-row flex-wrap">
                            <div class="filters" :class="{ 'filtersSelected':selectedFilter == 'product_name' }"
                                @click="selectedFilter = 'product_name'">
                                <el-dropdown trigger="click" :hide-on-click="hide_el_dropdown"
                                    @visible-change="dropdownTriggered">
                                    <span class="filters mr-1">
                                        <span>Product Name</span>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item>
                                            <span class="filterheader">Select Product Name</span>
                                            <a href="javascript:;"
                                                class="btn btn-new-outline-primary btn-xsm btn-sfFilter mr-0"
                                                @click="productNames = []; hide_el_dropdown = true; getListData()">Reset</a>
                                            <a href="javascript:;" class="btn btn-new-primary btn-xsm btn-sfFilter"
                                                @click="getListData(); hide_el_dropdown = true">Apply</a>
                                        </el-dropdown-item>
                                        <el-dropdown-item class="filter-select-dropdown">
                                            <multiselect :max-height="150"
                                                class="digi-multiselect sales-forecast-select" :loading="isLoading"
                                                v-model="productNames" @open="getProduts" @search-change="getProduts"
                                                @close="skip = 0;search_key = ''" :searchable="true"
                                                placeholder="Type to Search" :options="productoptions" :multiple="true"
                                                :taggable="false" :close-on-select="false" :show-labels="false"
                                                :clear-on-select="false" label="name" track-by="variant_id"
                                                open-direction="bottom">
                                                <template slot="afterList">
                                                    <div v-observe-visibility="getProdutsAfter" />
                                                </template>
                                                <template slot="noOptions">
                                                    <div class="text-secondary text-center fw-600">List is Empty</div>
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                            </multiselect>
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                            <div class="filters" :class="{ 'filtersSelected':selectedFilter == 'product_code' }"
                                @click="selectedFilter = 'product_code'">
                                <el-dropdown trigger="click" :hide-on-click="hide_el_dropdown"
                                    @visible-change="dropdownTriggered">
                                    <span class="filters mr-1">
                                        <span>Product Code</span>
                                    </span>
                                    <el-dropdown-menu slot="dropdown" class="branch-el">
                                        <el-dropdown-item>
                                            <span class="filterheader">Select Product Code</span>
                                            <a href="javascript:;"
                                                class="btn btn-new-outline-primary btn-xsm btn-sfFilter mr-0"
                                                @click="productCode = []; hide_el_dropdown = true; getListData()">Reset</a>
                                            <a href="javascript:;" class="btn btn-new-primary btn-xsm btn-sfFilter"
                                                @click="getListData(); hide_el_dropdown = true">Apply</a>
                                        </el-dropdown-item>
                                        <el-dropdown-item class="filter-select-dropdown">
                                            <multiselect :max-height="150"
                                                class="digi-multiselect sales-forecast-select" v-model="productCode"
                                                @open="getProduts" @search-change="getProduts"
                                                @close="skip = 0;search_key = ''" :loading="isLoading"
                                                :searchable="true" placeholder="Type to Search"
                                                :options="productoptions" :multiple="true" :taggable="false"
                                                :close-on-select="false" :show-labels="false" :clear-on-select="false"
                                                label="product_code" track-by="variant_id" open-direction="bottom">
                                                <template slot="afterList">
                                                    <div v-observe-visibility="getProdutsAfter" />
                                                </template>
                                                <template slot="noOptions">
                                                    <div class="text-secondary text-center fw-600">List is Empty</div>
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                            </multiselect>
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                            <div class="filters" :class="{ 'filtersSelected':selectedFilter == 'sales_person' }"
                                @click="selectedFilter = 'sales_person'">
                                <el-dropdown trigger="click" :hide-on-click="hide_el_dropdown"
                                    @visible-change="dropdownTriggered">
                                    <span class="filters mr-1">
                                        <span>Sales Person</span>
                                    </span>
                                    <el-dropdown-menu slot="dropdown" class="department-el">
                                        <el-dropdown-item>
                                            <span class="filterheader">Select Sales Person</span>
                                            <a href="javascript:;"
                                                class="btn btn-new-outline-primary btn-xsm btn-sfFilter mr-0"
                                                @click="salesPerson = []; hide_el_dropdown = true; getListData()">Reset</a>
                                            <a href="javascript:;" class="btn btn-new-primary btn-xsm btn-sfFilter"
                                                @click="getListData(); hide_el_dropdown = true">Apply</a>
                                        </el-dropdown-item>
                                        <el-dropdown-item class="filter-select-dropdown">
                                            <multiselect :max-height="150"
                                                class="digi-multiselect sales-forecast-select" v-model="salesPerson"
                                                @open="fetchSalesPerson" @search-change="fetchSalesPerson"
                                                @close="skip = 0;search_key = ''" :loading="loadSalesPerson"
                                                :searchable="true" placeholder="Type to Search" :options="salesperson"
                                                label="full_name" track-by="_id" :multiple="true" :taggable="false"
                                                :close-on-select="false" :show-labels="false" :clear-on-select="false"
                                                open-direction="bottom">
                                                <template slot="afterList">
                                                    <div v-observe-visibility="fetchSalesPersonAfter" />
                                                </template>
                                                <template slot="noOptions">
                                                    <div class="text-secondary text-center fw-600">List is Empty</div>
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                            </multiselect>
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </div>
                        <div class="close" @click="closeFilters">
                            <p>&times;</p>
                        </div>
                    </div>
                </div>
                <div style="width:100%;" class="mt-10 mb-5 callreportlist text-center"
                    v-if="!ajaxCallInProgress && tableData.length==0">
                    <div clas="text-center">
                        <h5 class="pt-3" style="color: #303031;font-size: 24px;font-weight: 800;">No Data</h5>
                    </div>
                </div>
                <div style="width:100%;" class="mt-2 mb-9" v-else>
                    <div :class="{ sales_overflow: show_multiselect == false }"
                        style="max-height: 450px; overflow: auto" id="printId">
                        <table class="table table-new-template head-sub sales-forecast-table">
                            <thead>
                                <tr>
                                    <th class="head" v-if="tableData.length==0"></th>
                                    <th class="head" v-else
                                        style="width: 1%; flex: 0 0 30px !important; padding: 0 26px !important">
                                        <label class="custom-control custom-checkbox digi-checkbox"
                                            style="width: 10px !important;padding-right: 0px !important;min-width: 10px;">
                                            <input v-model="selectAll" @click="clickedSelectAll()" type="checkbox"
                                                class="text-white custom-control-input" />
                                            <span class="custom-control-indicator"
                                                style="top: -5px !important;font-size: 20px;color: #fff !important;"></span>
                                            <span class="form-check-description fw-600"></span>
                                        </label>
                                    </th>
                                    <th class="head">Reference</th>
                                    <th class="head">Product Name</th>
                                    <th class="head">Sales Person</th>
                                    <th class="head">Product Code</th>
                                    <th class="head">UM</th>
                                    <th class="head">
                                        <span class="d-flex flex-column align-items-center">
                                            <span>Jan</span>
                                            <span v-if="quantityOnOff" class="d-flex justify-content-around"
                                                style="min-width: 160px; font-weight: 400; margin-top: 10px; margin-bottom: -10px">
                                                <span>Qty</span>
                                                <span>|</span>
                                                <span>Value</span>
                                            </span>
                                        </span>
                                    </th>
                                    <th class="head">
                                        <span class="d-flex flex-column align-items-center">
                                            <span>Feb</span>
                                            <span v-if="quantityOnOff" class="d-flex justify-content-around"
                                                style="min-width: 160px; font-weight: 400; margin-top: 10px; margin-bottom: -10px">
                                                <span>Qty</span>
                                                <span>|</span>
                                                <span>Value</span>
                                            </span>
                                        </span>
                                    </th>
                                    <th class="head">
                                        <span class="d-flex flex-column align-items-center">
                                            <span>Mar</span>
                                            <span v-if="quantityOnOff" class="d-flex justify-content-around"
                                                style="min-width: 160px; font-weight: 400; margin-top: 10px; margin-bottom: -10px">
                                                <span>Qty</span>
                                                <span>|</span>
                                                <span>Value</span>
                                            </span>
                                        </span>
                                    </th>
                                    <th class="head">
                                        <span class="d-flex flex-column align-items-center">
                                            <span>Apr</span>
                                            <span v-if="quantityOnOff" class="d-flex justify-content-around"
                                                style="min-width: 160px; font-weight: 400; margin-top: 10px; margin-bottom: -10px">
                                                <span>Qty</span>
                                                <span>|</span>
                                                <span>Value</span>
                                            </span>
                                        </span>
                                    </th>
                                    <th class="head">
                                        <span class="d-flex flex-column align-items-center">
                                            <span>May</span>
                                            <span v-if="quantityOnOff" class="d-flex justify-content-around"
                                                style="min-width: 160px; font-weight: 400; margin-top: 10px; margin-bottom: -10px">
                                                <span>Qty</span>
                                                <span>|</span>
                                                <span>Value</span>
                                            </span>
                                        </span>
                                    </th>
                                    <th class="head">
                                        <span class="d-flex flex-column align-items-center">
                                            <span>Jun</span>
                                            <span v-if="quantityOnOff" class="d-flex justify-content-around"
                                                style="min-width: 160px; font-weight: 400; margin-top: 10px; margin-bottom: -10px">
                                                <span>Qty</span>
                                                <span>|</span>
                                                <span>Value</span>
                                            </span>
                                        </span>
                                    </th>
                                    <th class="head">
                                        <span class="d-flex flex-column align-items-center">
                                            <span>Jul</span>
                                            <span v-if="quantityOnOff" class="d-flex justify-content-around"
                                                style="min-width: 160px; font-weight: 400; margin-top: 10px; margin-bottom: -10px">
                                                <span>Qty</span>
                                                <span>|</span>
                                                <span>Value</span>
                                            </span>
                                        </span>
                                    </th>
                                    <th class="head">
                                        <span class="d-flex flex-column align-items-center">
                                            <span>Aug</span>
                                            <span v-if="quantityOnOff" class="d-flex justify-content-around"
                                                style="min-width: 160px; font-weight: 400; margin-top: 10px; margin-bottom: -10px">
                                                <span>Qty</span>
                                                <span>|</span>
                                                <span>Value</span>
                                            </span>
                                        </span>
                                    </th>
                                    <th class="head">
                                        <span class="d-flex flex-column align-items-center">
                                            <span>SEPT</span>
                                            <span v-if="quantityOnOff" class="d-flex justify-content-around"
                                                style="min-width: 160px; font-weight: 400; margin-top: 10px; margin-bottom: -10px">
                                                <span>Qty</span>
                                                <span>|</span>
                                                <span>Value</span>
                                            </span>
                                        </span>
                                    </th>
                                    <th class="head">
                                        <span class="d-flex flex-column align-items-center">
                                            <span>Oct</span>
                                            <span v-if="quantityOnOff" class="d-flex justify-content-around"
                                                style="min-width: 160px; font-weight: 400; margin-top: 10px; margin-bottom: -10px">
                                                <span>Qty</span>
                                                <span>|</span>
                                                <span>Value</span>
                                            </span>
                                        </span>
                                    </th>
                                    <th class="head">
                                        <span class="d-flex flex-column align-items-center">
                                            <span>Nov</span>
                                            <span v-if="quantityOnOff" class="d-flex justify-content-around"
                                                style="min-width: 160px; font-weight: 400; margin-top: 10px; margin-bottom: -10px">
                                                <span>Qty</span>
                                                <span>|</span>
                                                <span>Value</span>
                                            </span>
                                        </span>
                                    </th>
                                    <th class="head">
                                        <span class="d-flex flex-column align-items-center">
                                            <span>Dec</span>
                                            <span v-if="quantityOnOff" class="d-flex justify-content-around"
                                                style="min-width: 160px; font-weight: 400; margin-top: 10px; margin-bottom: -10px">
                                                <span>Qty</span>
                                                <span>|</span>
                                                <span>Value</span>
                                            </span>
                                        </span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="ajaxCallInProgress && !tableData.sales">
                                    <td class="text-center" colspan="18">
                                        <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b"
                                            style="margin: 0 auto;" />
                                    </td>
                                </tr>
                                <tr v-if="!tableData.sales && !ajaxCallInProgress">
                                    <td colspan="18" class="text-center">
                                        <h5 class="pt-3" style="color: #303031;">No Data</h5>
                                    </td>
                                </tr>
                                <tr v-for="(t,index) in tableData.sales" :key="index" v-else>
                                    <td style="width: 1%; flex: 0 0 30px !important;padding: 0 26px !important">
                                        <label class="custom-control custom-checkbox digi-checkbox"
                                            style="width: 10px !important;padding-right: 0px !important;min-width: 10px;">
                                            <input v-model="deleteIds" :value="t._id" @click="handleDeleteIds(t._id)"
                                                type="checkbox" class="custom-control-input" />
                                            <span class="custom-control-indicator"
                                                style="font-size: 20px;top: -10px !important;"></span>
                                            <span class="form-check-description fw-600"></span>
                                        </label>
                                    </td>
                                    <td>
                                        <span v-if="editIds.includes(t._id)">
                                            <input v-validate="'required'" class="inputFieldTableSalesList"
                                                :name="'reference'+index" v-model="t.reference" type="text"
                                                placeholder="Enter Reference" disabled required />
                                            <span class="invalid-feedback-form text-danger"
                                                style="text-transform: none !important;"
                                                v-show="errors.has('reference'+index)">Required</span>
                                        </span>
                                        <span v-else>{{t.reference}}</span>
                                    </td>
                                    <td>
                                        <span v-if="editIds.includes(t._id)">
                                            <!-- <multiselect v-validate="'required'" :max-height="250"
                                                class="digi-multiselect loaderbgwhite"
                                                @select="updateProductCode($event,index)" v-model="t.product"
                                                @open="getProduts" @search-change="getProduts" @close="closeMultiselect"
                                                :block-keys="['Tab']" :searchable="true"
                                                placeholder="Select Product Name" :options="productoptions"
                                                :multiple="false" :taggable="false" :close-on-select="true"
                                                :show-labels="false" :clear-on-select="false" :hide-selected="false"
                                                :name="'product_name'+index" label="name"
                                                style="min-width: 180px; margin-top: 8px">
                                                <template slot="afterList">
                                                    <div v-observe-visibility="getProdutsAfter" />
                                                </template>
                                                <template slot="noOptions">
                                                    <div class="text-secondary text-center fw-600">List is Empty</div>
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                            </multiselect>
                                            <span class="invalid-feedback-form text-danger"
                                                style="text-transform: none !important;"
                                                v-show="errors.has('product_name'+index)">Required</span> -->
                                                <div class="forecastSumInput createsfinput" style="width: 15em; display: flex; overflow: hidden;">
                                                    <input v-validate="'required'" data-vv-as="Product Name"
                                                        class="inputFieldTableSalesList fw-500 pointer"
                                                        :name="'product_name'+index" v-model="t.product.name"
                                                        type="text" readonly placeholder="Select Product Name"
                                                        autocomplete="off" id="myAnchor"
                                                        @focus="selectProductDropdown(index,'')"
                                                        style="padding-right: 20px !important; text-overflow: ellipsis"
                                                    />
                                                    <i class="icon-menu-down"
                                                        @click="selectProductDropdown(index,'')"
                                                        style="margin-top: 12px; margin-left: -25px; color: #999">
                                                    </i>
                                                </div>
                                                <span class="invalid-feedback-form text-danger text-left text-capitalize mt-0"
                                                    style="margin-top: 0;font-weight: 400;"
                                                    v-show="errors.has('product_name'+index)">{{errors.first('product_name'+index)}}
                                                </span>
                                        </span>
                                        <span v-else>{{t.product.name}}</span>
                                    </td>
                                    <td>
                                        <span v-if="editIds.includes(t._id)">
                                            <div class="forecastSumInput createsfinput" style="width: 15em; display: flex; overflow: hidden;">
                                                <input v-validate="'required'"
                                                    class="inputFieldTableSalesList fw-500 pointer"
                                                    :name="'sales_person'+index" data-vv-as="Sales Person"
                                                    v-model="t.sales_person.full_name" type="text"
                                                    placeholder="Select Sales Person" autocomplete="off"
                                                    readonly id="myAnchor"
                                                    @focus="selectSalesPersonDropdown(index,'sales_person')"
                                                    style="padding-right: 20px !important; text-overflow: ellipsis"
                                                />
                                                <i class="icon-menu-down"
                                                    @click="selectSalesPersonDropdown(index,'sales_person')"
                                                    style="margin-top: 12px; margin-left: -25px; color: #999">
                                                </i>
                                            </div>
                                            <span class="invalid-feedback-form text-danger text-left text-capitalize mt-0"
                                                style="margin-top: 0;font-weight: 400;"
                                                v-show="errors.has('sales_person'+index)">{{errors.first('sales_person'+index)}}
                                            </span>
                                        </span>
                                        <span v-else>{{t.sales_person_name}}</span>
                                    </td>
                                    <td>
                                        <span v-if="editIds.includes(t._id)">
                                            <input v-validate="'required'" class="inputFieldTableSalesList"
                                                :name="'product_code'+index" readonly v-model="t.product_code"
                                                type="text" placeholder="Enter Product Code" />
                                            <span class="invalid-feedback-form text-danger"
                                                style="text-transform: none !important;"
                                                v-show="errors.has('product_code'+index)">Required</span>
                                        </span>
                                        <span v-else>{{t.product_code}}</span>
                                    </td>
                                    <td>
                                        <span v-if="editIds.includes(t._id)">
                                            <div class="forecastSumInput createsfinput" style="width: 10em; display: flex; overflow: hidden;">
                                                <input v-validate="'required'"
                                                    class="inputFieldTableSalesList fw-500 pointer"
                                                    :name="'um'+index" v-model="t.uom" type="text" readonly
                                                    placeholder="Select UM" autocomplete="off" id="myAnchor"
                                                    @focus="selectUMDropdown(index,'')" data-vv-as="UM"
                                                    style="padding-right: 20px !important; text-overflow: ellipsis"
                                                />
                                                <i class="icon-menu-down"
                                                    @click="selectUMDropdown(index,'')"
                                                    style="margin-top: 12px; margin-left: -25px; color: #999">
                                                </i>
                                            </div>
                                            <span class="invalid-feedback-form text-danger text-left text-capitalize mt-0" style="margin-top: 0;font-weight: 400;"
                                                v-show="errors.has('um'+index)">{{errors.first('um'+index)}}
                                            </span>
                                        </span>
                                        <span v-else>{{t.uom}}</span>
                                    </td>
                                    <td>
                                        <span class="d-flex text-center" style="min-width: 160px">
                                            <span v-if="quantityOnOff" style="min-width: 50%">
                                                <span v-if="editIds.includes(t._id)">
                                                    <div class="d-flex">
                                                        <input class="inputFieldTableSalesList" @input="sum('jan')"
                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                            :name="'target_jan'+index"
                                                            v-model.number="t.target.jan_quantity" type="text"
                                                            placeholder="Add Qty" required />
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger"
                                                        style="text-transform: none !important;position: absolute;margin-top: 0.4rem;"
                                                        v-show="errors.has('target_jan'+index)">Required</span>
                                                </span>
                                                <span v-else>{{t.target.jan_quantity || '-'}}</span>
                                            </span>
                                            <span class="text-center"
                                                :style="[quantityOnOff ? {'min-width': '50%'} : {'min-width': '100%'}]">
                                                <span v-if="editIds.includes(t._id)">
                                                    <div class="d-flex">
                                                        <label
                                                            style="padding-top: 16px;padding-right: 3px;">{{selectedCompany.currency.symbol}}</label>
                                                        <input v-validate="'required'" class="inputFieldTableSalesList"
                                                            @input="sum('jan')"
                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                            :name="'target_jan'+index" v-model.number="t.target.jan"
                                                            type="text" placeholder="Add Value" required />
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger"
                                                        style="text-transform: none !important;position: absolute;margin-top: 0.4rem;"
                                                        v-show="errors.has('target_jan'+index)">Required</span>
                                                </span>
                                                <span v-else>{{selectedCompany.currency.symbol}} {{t.target.jan}}</span>
                                            </span>
                                        </span>
                                    </td>
                                    <td>
                                        <span class="d-flex text-center" style="min-width: 160px">
                                            <span v-if="quantityOnOff" style="min-width: 50%">
                                                <span v-if="editIds.includes(t._id)">
                                                    <div class="d-flex">
                                                        <input class="inputFieldTableSalesList" @input="sum('feb')"
                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                            :name="'target_feb'+index"
                                                            v-model.number="t.target.feb_quantity" type="text"
                                                            placeholder="Add Qty" required />
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger"
                                                        style="text-transform: none !important;position: absolute;margin-top: 0.4rem;"
                                                        v-show="errors.has('target_feb'+index)">Required</span>
                                                </span>
                                                <span v-else>{{t.target.feb_quantity || '-'}}</span>
                                            </span>
                                            <span class="text-center"
                                                :style="[quantityOnOff ? {'min-width': '50%'} : {'min-width': '100%'}]">
                                                <span v-if="editIds.includes(t._id)">
                                                    <div class="d-flex">
                                                        <label
                                                            style="padding-top: 16px;padding-right: 3px;">{{selectedCompany.currency.symbol}}</label>
                                                        <input v-validate="'required'" class="inputFieldTableSalesList"
                                                            @input="sum('feb')"
                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                            :name="'target_feb'+index" v-model.number="t.target.feb"
                                                            type="text" placeholder="Add Value" required />
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger"
                                                        style="text-transform: none !important;position: absolute;margin-top: 0.4rem;"
                                                        v-show="errors.has('target_feb'+index)">Required</span>
                                                </span>
                                                <span v-else>{{selectedCompany.currency.symbol}} {{t.target.feb}}</span>
                                            </span>
                                        </span>
                                    </td>
                                    <td>
                                        <span class="d-flex text-center" style="min-width: 160px">
                                            <span v-if="quantityOnOff" style="min-width: 50%">
                                                <span v-if="editIds.includes(t._id)">
                                                    <div class="d-flex">
                                                        <input class="inputFieldTableSalesList" @input="sum('mar')"
                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                            :name="'target_mar'+index"
                                                            v-model.number="t.target.mar_quantity" type="text"
                                                            placeholder="Add Qty" required />
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger"
                                                        style="text-transform: none !important;position: absolute;margin-top: 0.4rem;"
                                                        v-show="errors.has('target_mar'+index)">Required</span>
                                                </span>
                                                <span v-else>{{t.target.mar_quantity || '-'}}</span>
                                            </span>
                                            <span class="text-center"
                                                :style="[quantityOnOff ? {'min-width': '50%'} : {'min-width': '100%'}]">
                                                <span v-if="editIds.includes(t._id)">
                                                    <div class="d-flex">
                                                        <label
                                                            style="padding-top: 16px;padding-right: 3px;">{{selectedCompany.currency.symbol}}</label>
                                                        <input v-validate="'required'" class="inputFieldTableSalesList"
                                                            @input="sum('mar')"
                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                            :name="'target_mar'+index" v-model.number="t.target.mar"
                                                            type="text" placeholder="Add Value" required />
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger"
                                                        style="text-transform: none !important;position: absolute;margin-top: 0.4rem;"
                                                        v-show="errors.has('target_mar'+index)">Required</span>
                                                </span>
                                                <span v-else>{{selectedCompany.currency.symbol}} {{t.target.mar}}</span>
                                            </span>
                                        </span>
                                    </td>
                                    <td>
                                        <span class="d-flex text-center" style="min-width: 160px">
                                            <span v-if="quantityOnOff" style="min-width: 50%">
                                                <span v-if="editIds.includes(t._id)">
                                                    <div class="d-flex">
                                                        <input class="inputFieldTableSalesList" @input="sum('apr')"
                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                            :name="'target_apr'+index"
                                                            v-model.number="t.target.apr_quantity" type="text"
                                                            placeholder="Add Qty" required />
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger"
                                                        style="text-transform: none !important;position: absolute;margin-top: 0.4rem;"
                                                        v-show="errors.has('target_apr'+index)">Required</span>
                                                </span>
                                                <span v-else>{{t.target.apr_quantity || '-'}}</span>
                                            </span>
                                            <span class="text-center"
                                                :style="[quantityOnOff ? {'min-width': '50%'} : {'min-width': '100%'}]">
                                                <span v-if="editIds.includes(t._id)">
                                                    <div class="d-flex">
                                                        <label
                                                            style="padding-top: 16px;padding-right: 3px;">{{selectedCompany.currency.symbol}}</label>
                                                        <input v-validate="'required'" class="inputFieldTableSalesList"
                                                            @input="sum('apr')"
                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                            :name="'target_apr'+index" v-model.number="t.target.apr"
                                                            type="text" placeholder="Add Value" required />
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger"
                                                        style="text-transform: none !important;position: absolute;margin-top: 0.4rem;"
                                                        v-show="errors.has('target_apr'+index)">Required</span>
                                                </span>
                                                <span v-else>{{selectedCompany.currency.symbol}} {{t.target.apr}}</span>
                                            </span>
                                        </span>
                                    </td>
                                    <td>
                                        <span class="d-flex text-center" style="min-width: 160px">
                                            <span v-if="quantityOnOff" style="min-width: 50%">
                                                <span v-if="editIds.includes(t._id)">
                                                    <div class="d-flex">
                                                        <input class="inputFieldTableSalesList" @input="sum('may')"
                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                            :name="'target_may'+index"
                                                            v-model.number="t.target.may_quantity" type="text"
                                                            placeholder="Add Qty" required />
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger"
                                                        style="text-transform: none !important;position: absolute;margin-top: 0.4rem;"
                                                        v-show="errors.has('target_may'+index)">Required</span>
                                                </span>
                                                <span v-else>{{t.target.may_quantity || '-'}}</span>
                                            </span>
                                            <span class="text-center"
                                                :style="[quantityOnOff ? {'min-width': '50%'} : {'min-width': '100%'}]">
                                                <span v-if="editIds.includes(t._id)">
                                                    <div class="d-flex">
                                                        <label
                                                            style="padding-top: 16px;padding-right: 3px;">{{selectedCompany.currency.symbol}}</label>
                                                        <input v-validate="'required'" class="inputFieldTableSalesList"
                                                            @input="sum('may')"
                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                            :name="'target_may'+index" v-model.number="t.target.may"
                                                            type="text" placeholder="Add Value" required />
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger"
                                                        style="text-transform: none !important;position: absolute;margin-top: 0.4rem;"
                                                        v-show="errors.has('target_may'+index)">Required</span>
                                                </span>
                                                <span v-else>{{selectedCompany.currency.symbol}} {{t.target.may}}</span>
                                            </span>
                                        </span>
                                    </td>
                                    <td>
                                        <span class="d-flex text-center" style="min-width: 160px">
                                            <span v-if="quantityOnOff" style="min-width: 50%">
                                                <span v-if="editIds.includes(t._id)">
                                                    <div class="d-flex">
                                                        <input class="inputFieldTableSalesList" @input="sum('jun')"
                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                            :name="'target_jun'+index"
                                                            v-model.number="t.target.jun_quantity" type="text"
                                                            placeholder="Add Qty" required />
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger"
                                                        style="text-transform: none !important;position: absolute;margin-top: 0.4rem;"
                                                        v-show="errors.has('target_jun'+index)">Required</span>
                                                </span>
                                                <span v-else>{{t.target.jun_quantity || '-'}}</span>
                                            </span>
                                            <span class="text-center"
                                                :style="[quantityOnOff ? {'min-width': '50%'} : {'min-width': '100%'}]">
                                                <span v-if="editIds.includes(t._id)">
                                                    <div class="d-flex">
                                                        <label
                                                            style="padding-top: 16px;padding-right: 3px;">{{selectedCompany.currency.symbol}}</label>
                                                        <input v-validate="'required'" class="inputFieldTableSalesList"
                                                            @input="sum('jun')"
                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                            :name="'target_jun'+index" v-model.number="t.target.jun"
                                                            type="text" placeholder="Add Value" required />
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger"
                                                        style="text-transform: none !important;position: absolute;margin-top: 0.4rem;"
                                                        v-show="errors.has('target_jun'+index)">Required</span>
                                                </span>
                                                <span v-else>{{selectedCompany.currency.symbol}} {{t.target.jun}}</span>
                                            </span>
                                        </span>
                                    </td>
                                    <td>
                                        <span class="d-flex text-center" style="min-width: 160px">
                                            <span v-if="quantityOnOff" style="min-width: 50%">
                                                <span v-if="editIds.includes(t._id)">
                                                    <div class="d-flex">
                                                        <input class="inputFieldTableSalesList" @input="sum('jul')"
                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                            :name="'target_jul'+index"
                                                            v-model.number="t.target.jul_quantity" type="text"
                                                            placeholder="Add Qty" required />
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger"
                                                        style="text-transform: none !important;position: absolute;margin-top: 0.4rem;"
                                                        v-show="errors.has('target_jul'+index)">Required</span>
                                                </span>
                                                <span v-else>{{t.target.jul_quantity || '-'}}</span>
                                            </span>
                                            <span class="text-center"
                                                :style="[quantityOnOff ? {'min-width': '50%'} : {'min-width': '100%'}]">
                                                <span v-if="editIds.includes(t._id)">
                                                    <div class="d-flex">
                                                        <label
                                                            style="padding-top: 16px;padding-right: 3px;">{{selectedCompany.currency.symbol}}</label>
                                                        <input v-validate="'required'" class="inputFieldTableSalesList"
                                                            @input="sum('jul')"
                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                            :name="'target_jul'+index" v-model.number="t.target.jul"
                                                            type="text" placeholder="Add Value" required />
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger"
                                                        style="text-transform: none !important;position: absolute;margin-top: 0.4rem;"
                                                        v-show="errors.has('target_jul'+index)">Required</span>
                                                </span>
                                                <span v-else>{{selectedCompany.currency.symbol}} {{t.target.jul}}</span>
                                            </span>
                                        </span>
                                    </td>
                                    <td>
                                        <span class="d-flex text-center" style="min-width: 160px">
                                            <span v-if="quantityOnOff" style="min-width: 50%">
                                                <span v-if="editIds.includes(t._id)">
                                                    <div class="d-flex">
                                                        <input class="inputFieldTableSalesList" @input="sum('aug')"
                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                            :name="'target_aug'+index"
                                                            v-model.number="t.target.aug_quantity" type="text"
                                                            placeholder="Add Qty" required />
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger"
                                                        style="text-transform: none !important;position: absolute;margin-top: 0.4rem;"
                                                        v-show="errors.has('target_aug'+index)">Required</span>
                                                </span>
                                                <span v-else>{{t.target.aug_quantity || '-'}}</span>
                                            </span>
                                            <span class="text-center"
                                                :style="[quantityOnOff ? {'min-width': '50%'} : {'min-width': '100%'}]">
                                                <span v-if="editIds.includes(t._id)">
                                                    <div class="d-flex">
                                                        <label
                                                            style="padding-top: 16px;padding-right: 3px;">{{selectedCompany.currency.symbol}}</label>
                                                        <input v-validate="'required'" class="inputFieldTableSalesList"
                                                            @input="sum('aug')"
                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                            :name="'target_aug'+index" v-model.number="t.target.aug"
                                                            type="text" placeholder="Add Value" required />
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger"
                                                        style="text-transform: none !important;position: absolute;margin-top: 0.4rem;"
                                                        v-show="errors.has('target_aug'+index)">Required</span>
                                                </span>
                                                <span v-else>{{selectedCompany.currency.symbol}} {{t.target.aug}}</span>
                                            </span>
                                        </span>
                                    </td>
                                    <td>
                                        <span class="d-flex text-center" style="min-width: 160px">
                                            <span v-if="quantityOnOff" style="min-width: 50%">
                                                <span v-if="editIds.includes(t._id)">
                                                    <div class="d-flex">
                                                        <input class="inputFieldTableSalesList" @input="sum('sept')"
                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                            :name="'target_sept'+index"
                                                            v-model.number="t.target.sept_quantity" type="text"
                                                            placeholder="Add Qty" required />
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger"
                                                        style="text-transform: none !important;position: absolute;margin-top: 0.4rem;"
                                                        v-show="errors.has('target_sept'+index)">Required</span>
                                                </span>
                                                <span v-else>{{t.target.sept_quantity || '-'}}</span>
                                            </span>
                                            <span class="text-center"
                                                :style="[quantityOnOff ? {'min-width': '50%'} : {'min-width': '100%'}]">
                                                <span v-if="editIds.includes(t._id)">
                                                    <div class="d-flex">
                                                        <label
                                                            style="padding-top: 16px;padding-right: 3px;">{{selectedCompany.currency.symbol}}</label>
                                                        <input v-validate="'required'" class="inputFieldTableSalesList"
                                                            @input="sum('sept')"
                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                            :name="'target_sept'+index" v-model.number="t.target.sept"
                                                            type="text" placeholder="Add Value" required />
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger"
                                                        style="text-transform: none !important;position: absolute;margin-top: 0.4rem;"
                                                        v-show="errors.has('target_sept'+index)">Required</span>
                                                </span>
                                                <span v-else>{{selectedCompany.currency.symbol}}
                                                    {{t.target.sept}}</span>
                                            </span>
                                        </span>
                                    </td>
                                    <td>
                                        <span class="d-flex text-center" style="min-width: 160px">
                                            <span v-if="quantityOnOff" style="min-width: 50%">
                                                <span v-if="editIds.includes(t._id)">
                                                    <div class="d-flex">
                                                        <input class="inputFieldTableSalesList" @input="sum('oct')"
                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                            :name="'target_oct'+index"
                                                            v-model.number="t.target.oct_quantity" type="text"
                                                            placeholder="Add Qty" required />
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger"
                                                        style="text-transform: none !important;position: absolute;margin-top: 0.4rem;"
                                                        v-show="errors.has('target_oct'+index)">Required</span>
                                                </span>
                                                <span v-else>{{t.target.oct_quantity || '-'}}</span>
                                            </span>
                                            <span class="text-center"
                                                :style="[quantityOnOff ? {'min-width': '50%'} : {'min-width': '100%'}]">
                                                <span v-if="editIds.includes(t._id)">
                                                    <div class="d-flex">
                                                        <label
                                                            style="padding-top: 16px;padding-right: 3px;">{{selectedCompany.currency.symbol}}</label>
                                                        <input v-validate="'required'" class="inputFieldTableSalesList"
                                                            @input="sum('oct')"
                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                            :name="'target_oct'+index" v-model.number="t.target.oct"
                                                            type="text" placeholder="Add Value" required />
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger"
                                                        style="text-transform: none !important;position: absolute;margin-top: 0.4rem;"
                                                        v-show="errors.has('target_oct'+index)">Required</span>
                                                </span>
                                                <span v-else>{{selectedCompany.currency.symbol}} {{t.target.oct}}</span>
                                            </span>
                                        </span>
                                    </td>
                                    <td>
                                        <span class="d-flex text-center" style="min-width: 160px">
                                            <span v-if="quantityOnOff" style="min-width: 50%">
                                                <span v-if="editIds.includes(t._id)">
                                                    <div class="d-flex">
                                                        <input class="inputFieldTableSalesList" @input="sum('nov')"
                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                            :name="'target_nov'+index"
                                                            v-model.number="t.target.nov_quantity" type="text"
                                                            placeholder="Add Qty" required />
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger"
                                                        style="text-transform: none !important;position: absolute;margin-top: 0.4rem;"
                                                        v-show="errors.has('target_nov'+index)">Required</span>
                                                </span>
                                                <span v-else>{{t.target.nov_quantity || '-'}}</span>
                                            </span>
                                            <span class="text-center"
                                                :style="[quantityOnOff ? {'min-width': '50%'} : {'min-width': '100%'}]">
                                                <span v-if="editIds.includes(t._id)">
                                                    <div class="d-flex">
                                                        <label
                                                            style="padding-top: 16px;padding-right: 3px;">{{selectedCompany.currency.symbol}}</label>
                                                        <input v-validate="'required'" class="inputFieldTableSalesList"
                                                            @input="sum('nov')"
                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                            :name="'target_nov'+index" v-model.number="t.target.nov"
                                                            type="text" placeholder="Add Value" required />
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger"
                                                        style="text-transform: none !important;position: absolute;margin-top: 0.4rem;"
                                                        v-show="errors.has('target_nov'+index)">Required</span>
                                                </span>
                                                <span v-else>{{selectedCompany.currency.symbol}} {{t.target.nov}}</span>
                                            </span>
                                        </span>
                                    </td>
                                    <td>
                                        <span class="d-flex text-center" style="min-width: 160px">
                                            <span v-if="quantityOnOff" style="min-width: 50%">
                                                <span v-if="editIds.includes(t._id)">
                                                    <div class="d-flex">
                                                        <input class="inputFieldTableSalesList" @input="sum('dec')"
                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                            :name="'target_dec'+index"
                                                            v-model.number="t.target.dec_quantity" type="text"
                                                            placeholder="Add Qty" required />
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger"
                                                        style="text-transform: none !important;position: absolute;margin-top: 0.4rem;"
                                                        v-show="errors.has('target_dec'+index)">Required</span>
                                                </span>
                                                <span v-else>{{t.target.dec_quantity || '-'}}</span>
                                            </span>
                                            <span class="text-center"
                                                :style="[quantityOnOff ? {'min-width': '50%'} : {'min-width': '100%'}]">
                                                <span v-if="editIds.includes(t._id)">
                                                    <div class="d-flex">
                                                        <label
                                                            style="padding-top: 16px;padding-right: 3px;">{{selectedCompany.currency.symbol}}</label>
                                                        <input v-validate="'required'" class="inputFieldTableSalesList"
                                                            @input="sum('dec')"
                                                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                            :name="'target_dec'+index" v-model.number="t.target.dec"
                                                            type="text" placeholder="Add Value" required />
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger"
                                                        style="text-transform: none !important;position: absolute;margin-top: 0.4rem;"
                                                        v-show="errors.has('target_dec'+index)">Required</span>
                                                </span>
                                                <span v-else>{{selectedCompany.currency.symbol}} {{t.target.dec}}</span>
                                            </span>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot v-if="tableData.sales && !ajaxCallInProgress">
                                <tr class="font-weight-bold">
                                    <td style="width: 1%; flex: 0 0 30px !important;"></td>
                                    <td class="font-weight-bold">Total</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td class="font-weight-bold">
                                        <span class="d-flex text-center" style="min-width: 160px">
                                            <span v-if="quantityOnOff" style="min-width: 50%"></span>
                                            <span class="text-center"
                                                :style="[quantityOnOff ? {'min-width': '50%'} : {'min-width': '100%'}]">{{selectedCompany.currency.symbol}}
                                                {{tableData.jan}}</span>
                                        </span>
                                    </td>
                                    <td class="font-weight-bold">
                                        <span class="d-flex text-center" style="min-width: 160px">
                                            <span v-if="quantityOnOff" style="min-width: 50%"></span>
                                            <span class="text-center"
                                                :style="[quantityOnOff ? {'min-width': '50%'} : {'min-width': '100%'}]">{{selectedCompany.currency.symbol}}
                                                {{tableData.feb}}</span>
                                        </span>
                                    </td>
                                    <td class="font-weight-bold">
                                        <span class="d-flex text-center" style="min-width: 160px">
                                            <span v-if="quantityOnOff" style="min-width: 50%"></span>
                                            <span class="text-center"
                                                :style="[quantityOnOff ? {'min-width': '50%'} : {'min-width': '100%'}]">{{selectedCompany.currency.symbol}}
                                                {{tableData.mar}}</span>
                                        </span>
                                    </td>
                                    <td class="font-weight-bold">
                                        <span class="d-flex text-center" style="min-width: 160px">
                                            <span v-if="quantityOnOff" style="min-width: 50%"></span>
                                            <span class="text-center"
                                                :style="[quantityOnOff ? {'min-width': '50%'} : {'min-width': '100%'}]">{{selectedCompany.currency.symbol}}
                                                {{tableData.apr}}</span>
                                        </span>
                                    </td>
                                    <td class="font-weight-bold">
                                        <span class="d-flex text-center" style="min-width: 160px">
                                            <span v-if="quantityOnOff" style="min-width: 50%"></span>
                                            <span class="text-center"
                                                :style="[quantityOnOff ? {'min-width': '50%'} : {'min-width': '100%'}]">{{selectedCompany.currency.symbol}}
                                                {{tableData.may}}</span>
                                        </span>
                                    </td>
                                    <td>
                                        <span class="d-flex text-center" style="min-width: 160px">
                                            <span v-if="quantityOnOff" style="min-width: 50%"></span>
                                            <span class="text-center"
                                                :style="[quantityOnOff ? {'min-width': '50%'} : {'min-width': '100%'}]">{{selectedCompany.currency.symbol}}
                                                {{tableData.jun}}</span>
                                        </span>
                                    </td>
                                    <td class="font-weight-bold">
                                        <span class="d-flex text-center" style="min-width: 160px">
                                            <span v-if="quantityOnOff" style="min-width: 50%"></span>
                                            <span class="text-center"
                                                :style="[quantityOnOff ? {'min-width': '50%'} : {'min-width': '100%'}]">{{selectedCompany.currency.symbol}}
                                                {{tableData.jul}}</span>
                                        </span>
                                    </td>
                                    <td class="font-weight-bold">
                                        <span class="d-flex text-center" style="min-width: 160px">
                                            <span v-if="quantityOnOff" style="min-width: 50%"></span>
                                            <span class="text-center"
                                                :style="[quantityOnOff ? {'min-width': '50%'} : {'min-width': '100%'}]">{{selectedCompany.currency.symbol}}
                                                {{tableData.aug}}</span>
                                        </span>
                                    </td>
                                    <td class="font-weight-bold">
                                        <span class="d-flex text-center" style="min-width: 160px">
                                            <span v-if="quantityOnOff" style="min-width: 50%"></span>
                                            <span class="text-center"
                                                :style="[quantityOnOff ? {'min-width': '50%'} : {'min-width': '100%'}]">{{selectedCompany.currency.symbol}}
                                                {{tableData.sept}}</span>
                                        </span>
                                    </td>
                                    <td class="font-weight-bold">
                                        <span class="d-flex text-center" style="min-width: 160px">
                                            <span v-if="quantityOnOff" style="min-width: 50%"></span>
                                            <span class="text-center"
                                                :style="[quantityOnOff ? {'min-width': '50%'} : {'min-width': '100%'}]">{{selectedCompany.currency.symbol}}
                                                {{tableData.oct}}</span>
                                        </span>
                                    </td>
                                    <td class="font-weight-bold">
                                        <span class="d-flex text-center" style="min-width: 160px">
                                            <span v-if="quantityOnOff" style="min-width: 50%"></span>
                                            <span class="text-center"
                                                :style="[quantityOnOff ? {'min-width': '50%'} : {'min-width': '100%'}]">{{selectedCompany.currency.symbol}}
                                                {{tableData.nov}}</span>
                                        </span>
                                    </td>
                                    <td class="font-weight-bold">
                                        <span class="d-flex text-center" style="min-width: 160px">
                                            <span v-if="quantityOnOff" style="min-width: 50%"></span>
                                            <span class="text-center"
                                                :style="[quantityOnOff ? {'min-width': '50%'} : {'min-width': '100%'}]">{{selectedCompany.currency.symbol}}
                                                {{tableData.dec}}</span>
                                        </span>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                    <div class="mt-4" v-if="editIds.length > 0">
                        <button class="btn-table" @click="addProduct">+
                            Add Product</button>
                    </div>
                    <div v-if="!ajaxCallInProgress && attachments.length || editIds.length > 0" class="mt-10 mx-10">
                        <span class="fs-14 fw-800"
                            style="color: #303031 !important;top: 0px !important;">Attachments</span>
                    </div>
                    <div v-if="!ajaxCallInProgress && showEditDelete" class="mt-2">
                        <div class="form-group" v-if="editIds.length > 0">
                            <div class="attachment mt-5">
                                <span class="d-flex justify-content-center text-white fw-600 fs-14 py-4"
                                    style="border-top-left-radius: 12px; border-top-right-radius: 12px; background: #00448b;">ADD
                                    ATTACHMENTS</span>
                                <div class="upload-main d-flex flex-column justify-content-center align-items-center pl-0"
                                    style="height: 18em; background: #f5f5f5; border-bottom-left-radius: 6px; border-bottom-right-radius: 6px;">
                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/upload-icon.svg" style="width: 3.5em; height: 3.5em">
                                    <span class="fs-12 fw-500 mt-2">
                                        Drag and Drop File
                                        <el-tooltip effect="dark" placement="left" style="width: 21em;">
                                            <div slot="content" style="color: #fff; font-size: 12px;">
                                                <span style="font-weight: 600;">Drag and Drop File</span>
                                            </div>
                                            <i class="icon-information text-secondary" style="font-size: 15px;"></i>
                                        </el-tooltip>
                                    </span>
                                    <!-- .htm, .html, .flv -->
                                    <span>File Type : Document - [ .doc, .docx, .pdf, .ppt, .pptx, .txt,
                                        .Xls, .xlsx <span style="color: #00448b">- ( File Limit : 10 Files of 10 MB Each
                                            ) ]</span></span>
                                    <span>File Type : Image- [ .bmp, .gif, .jpeg, .png, .svg, .tiff <span
                                            style="color: #00448b">- ( File Limit : 10 files of 10 MB each
                                            )]</span></span>
                                    <span>File Type : Video/Audio -[ .avi, .mpg, .mpeg, .mp3, .mp4, .wav, .wmv
                                        <span style="color: #00448b">- ( File Limit : 10 files of 10 MB each )
                                            ]</span></span>
                                    <span class="fs-12 fw-500 mt-2">or</span>
                                    <file-upload class="choose-file btn btn-des-small mt-2" :multiple="true"
                                        :drop="true" :drop-directory="true" @input-file="uploadAttachment" ref="upload"
                                        style="text-transform: none !important; color: #fff; background: #1c61c2; border: 1px solid #1c61c2; width: 8em;">
                                        Browse
                                    </file-upload>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="!ajaxCallInProgress && attachments.length">
                        <div v-if="attachments.length" class="row mx-0">
                            <div v-if="files.length" class="files-attachments mt-10">
                                <span class="d-flex justify-content-center text-white fw-600 fs-14 py-4"
                                    style="border-top-left-radius: 12px; border-top-right-radius: 12px; background: #00448b;">FILES</span>
                                <div class="_files" v-for="(file,index) in files" :key="index">
                                    <div class="d-flex justify-content-between w-100">
                                        <div>
                                            <img v-if="file.name.endsWith('.pdf')"
                                                src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg" />
                                            <img v-else-if="file.name.endsWith('.png')"
                                                src="https://cdn.digicollect.com/cdn/scmnew/images/scm/png-attachment.svg" />
                                            <img v-else-if="file.name.endsWith('.jpg')"
                                                src="https://cdn.digicollect.com/cdn/scmnew/images/scm/jpg.svg" />
                                            <img v-else-if="file.name.endsWith('.svg')"
                                                src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg" />
                                            <img v-else-if="file.name.endsWith('.xls') || file.name.endsWith('.xlsx')"
                                                src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg" />
                                            <img v-else-if="file.name.endsWith('.doc') || file.name.endsWith('.docx')"
                                                src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg" />
                                            <span class="ml-2 fw-600 text-dark fs-14">
                                                {{ file.name }} <span class="ml-3"
                                                    style="color:#808495">({{ file.size }})</span>
                                            </span>
                                        </div>
                                        <div>
                                            <a :href="file.url" download style="text-decoration: none;">
                                                <i class="icon icon-download"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="images.length" class="files-attachments mt-8">
                                <span class="d-flex justify-content-center text-white fw-600 fs-14 py-4"
                                    style="border-top-left-radius: 12px; border-top-right-radius: 12px; background: #00448b;">IMAGES</span>
                                <div class="report-images">
                                    <div v-for="(image,index) in images" :key="index">
                                        <span class="_images pointer" style="position: relative;"
                                            @click="previewImage(image)">
                                            <a class="mr-3 pointer img_more" :href="image.url" download>
                                                <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/download_img.svg"
                                                    alt="" style="width:15px">
                                            </a>
                                            <img :src="image.url" alt="">
                                            <span>{{ image.name }}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div v-if="audiovideo.length" class="files-attachments mt-8">
                                <span class="d-flex justify-content-center text-white fw-600 fs-14 py-4"
                                    style="border-top-left-radius: 12px; border-top-right-radius: 12px; background: #00448b;">AUDIOS
                                    / VIDEOS</span>
                                <div class="report-images">
                                    <div class="_images" style="position: relative;"
                                        v-for="(audiovid,index) in audiovideo" :key="index">
                                        <a class="mr-3 pointer img_more" :href="audiovid.url" download>
                                            <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/download_img.svg"
                                                alt="" style="width:15px">
                                        </a>
                                        <video controls>
                                            <source :src="audiovid.url" type="video/*">
                                        </video>
                                        <span>{{ audiovid.name }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="row mt-4" v-if="editIds.length > 0">
                        <div class="col-lg-12 text-center mt-10">
                        <button
                            class="btn btn-new-darkdanger btn-slight text-white mr-2"
                            style="border-radius: 8px !important;min-width: 9.8rem;"
                            @click="cancel()"
                        >Cancel</button>
                        <button
                            class="btn btn-new-darksuccess text-white btn-slight"
                            style="border-radius: 8px !important;min-width: 9.8rem;"
                            @click="save()"
                        >Save</button>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
        <preview @hidePreview="hidePreview" v-if="preview_visible" :file_preview="preview_file"></preview>
        <select-product-sale-forecast v-if="select_product_sales_forecast" modal_name="selectProductSalesForecast" @selectedProduct="selectedProduct">
        </select-product-sale-forecast>
        <select-sales-person-forecast v-if="select_sales_person_forecast" modal_name="selectSalesPersonForecast" @selectedSalesPerson="selectedSalesPerson">
        </select-sales-person-forecast>
        <select-u-m-forecast v-if="select_UM_forecast" modal_name="selectUMForecast" @selectedUM="selectedUM"></select-u-m-forecast>
    </div>
</template>
<script>
    import customer from "./mixins/customer";
    import print from "./mixins/print";
    import {
        HalfCircleSpinner
    } from "epic-spinners";
    import globals from "./globals";
    var mime = require('mime-types')
    const Preview = () => import("./Preview");
    const {
        uuid
    } = require('uuidv4');
    import uploadSalesforecasting from "./mixins/uploadSalesForecast.js";
    import SelectProductSaleForecast from "./alertModals/SelectProductSaleForecast";
    import SelectSalesPersonForecast from "./alertModals/SelectSalesPersonForecast";
    import SelectUMForecast from "./alertModals/SelectUMForecast";
    export default {
        mixins: [customer, print, uploadSalesforecasting],
        data() {
            return {
                dType: [{
                        id: "forecast",
                        name: "Forecast for Year",
                    },
                    {
                        id: "actual_sales",
                        name: "Current Sales For Year",
                    },
                ],
                select_product_sales_forecast: false,
                select_sales_person_forecast: false,
                select_UM_forecast: false,
                selectCompany: "",
                departmentName: "",
                branchName: "",
                document_type: {
                    id: "forecast",
                    name: "Forecast for Year",
                },
                mainSalesPerson: "",
                target_year: "Fiscal Year",
                sales_number_id: "",
                skip: 0,
                limit: 10,
                isLoading: false,
                scrollable: false,
                branchs: [],
                customers: [],
                departments: [],
                tableData: [],
                deleteIds: [],
                editIds: [],
                selectAll: false,
                showEditDelete: false,
                showEdit: false,
                start: 1,
                end: 0,
                count: 0,
                totalSaleForecast: 0,
                ajaxCallInProgress: false,
                saveEdit: [],
                quantityOnOff: true,
                years_to_set: [],
                hide_el_dropdown: false,
                filterblock: false,
                selectedFilter: "",
                salesperson: [],
                salesPerson: [],
                newtarget: {
                    _id: "",
                    reference: "MANUAL",
                    sales_person: "",
                    product: "",
                    product_code: "",
                    uom: "",
                    target: {
                        jan: 0,
                        jan_quantity: 0,
                        feb: 0,
                        feb_quantity: 0,
                        mar: 0,
                        mar_quantity: 0,
                        apr: 0,
                        apr_quantity: 0,
                        may: 0,
                        may_quantity: 0,
                        jun: 0,
                        jun_quantity: 0,
                        jul: 0,
                        jul_quantity: 0,
                        aug: 0,
                        aug_quantity: 0,
                        sept: 0,
                        sept_quantity: 0,
                        oct: 0,
                        oct_quantity: 0,
                        nov: 0,
                        nov_quantity: 0,
                        dec: 0,
                        dec_quantity: 0,
                    },
                },
                uoms: [],
                productoptions: [],
                editedNew: [],
                productNames: [],
                productCode: [],
                search_key: "",
                target_year_selected: "",
                documentTypeSelectedInside: false,
                viewCompanyUpdated: "",
                show_multiselect: false,
                loadSalesPerson: false,
                attachments: [],
                files: [],
                images: [],
                audiovideo: [],
                dialogImageUrl: '',
                activeSave: true,
                preview_file: '',
                preview_visible: false,
                selectedIndex: "",
                activeSalesView:false,
                skip_temp:0,
                temp_total:0
            };
        },
        components: {
            HalfCircleSpinner,
            Preview,
            SelectProductSaleForecast,
            SelectSalesPersonForecast,
            SelectUMForecast
        },
        mounted() {
            this.getDataToView();
            this.getuom();
        },
        methods: {
            previousPage() {
                this.temp_total = 0
                this.skip_temp = 0
                if (this.skip == 0) {
                    return;
                }
                this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
                this.getDataToView();
            },
            nextPage() {
                this.skip_temp = this.skip + this.limit > this.totalSaleForecast ? this.totalSaleForecast : this.skip + this.limit;
                if (this.skip_temp >= this.totalSaleForecast) {
                    return;
                }
                this.skip = this.skip_temp;
                this.getDataToView();
            },
            selectProductDropdown(index) {
                this.selectedIndex = index;
                this.select_product_sales_forecast = true;
                setTimeout(() => {
                    this.$modal.show("selectProductSalesForecast");
                }, 500);
            },
            selectedProduct(option) {
                this.tableData.sales[this.selectedIndex].product = option;
                this.tableData.sales[this.selectedIndex].product_code = option.product_code;
                this.select_product_sales_forecast = false;
                this.$forceUpdate()
                this.errors.clear();
                this.$validator.reset();
            },
            selectSalesPersonDropdown(index) {
                this.selectedIndex = index;
                this.select_sales_person_forecast = true;
                setTimeout(() => {
                    this.$modal.show("selectSalesPersonForecast");
                }, 500);
            },
            selectedSalesPerson(option) {
                this.tableData.sales[this.selectedIndex].sales_person = option;
                this.select_sales_person_forecast = false;
                this.errors.clear();
                this.$validator.reset();
            },
            selectUMDropdown(index) {
                this.selectedIndex = index;
                this.select_UM_forecast = true;
                setTimeout(() => {
                    this.$modal.show("selectUMForecast");
                }, 500);
                this.errors.clear();
                this.$validator.reset();
            },
            selectedUM(option) {
                this.tableData.sales[this.selectedIndex].uom = option;
                this.select_UM_forecast = false;
            },
            hidePreview() {
                this.preview_visible = false
            },
            previewImage(file) {
                let content_type = mime.lookup(file.name) ? mime.lookup(file.name) : 'application/octet-stream';
                file['content_type'] = content_type;
                this.preview_file = file;
                this.preview_visible = true;
            },
            openFilters() {
                this.filterblock = true;
            },
            closeFilters() {
                this.filterblock = false;
            },
            editsales() {
                this.editIds = this.deleteIds;
                this.activeSave = false
                this.showEditDelete = true;
                this.activeSalesView = true;
            },
            save() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.callAPi();
                        this.showEditDelete = false;
                        this.activeSalesView = false
                        this.editIds = [];
                        this.deleteIds = [];
                    } else {
                        this.$swal({
                            title: "",
                            text: "Please Fill All Required Fields",
                            type: "warning",
                            confirmButtonColor: "#005dae",
                        });
                    }
                });
            },
            cancel() {
                this.getDataToView();
                this.activeSave = true
                this.saveEdit = [];
                this.showEditDelete = false;
                this.editIds = [];
                this.deleteIds = [];
                this.activeSalesView = false;
                // this.$router.push("/listsalesforecast");
            },
            sum(month) {
                let total = 0;
                this.tableData.sales.forEach(x => {
                    total += x.target[`${month}_quantity`] > 0 ? x.target[month] * x.target[
                        `${month}_quantity`] : x.target[month];
                });
                this.tableData[month] = total;
            },
            addProduct() {
                this.tableData.sales.push(JSON.parse(JSON.stringify(this.newtarget)));
                this.tableData.sales.forEach(x => {
                    if (!x._id) {
                        x._id = uuid();
                    }
                });
                this.editIds.push(this.tableData.sales[this.tableData.sales.length - 1]._id);
                this.editedNew.push(this.tableData.sales.length - 1);
            },
            async callAPi() {
                let params = {};
                let editData = [];
                let newProd = {
                    _id: this.tableData.sales_id,
                    forecast: [],
                    attachments: [],
                };
                if (this.editedNew.length > 0) {
                    this.tableData.sales.forEach((x, index) => {
                        for (let p of this.editedNew) {
                            if (p == index) {
                                newProd.forecast.push({
                                    product_id: x.product._id,
                                    category: x.product.category,
                                    sub_category: x.product.sub_category,
                                    product_code: x.product_code,
                                    product: x.product.name,
                                    sales_person: x.sales_person._id,
                                    uom: x.uom,
                                    target: x.target,
                                });
                            } else {
                                editData.push({
                                    _id: x._id,
                                    product_id: x.product._id,
                                    category: x.product.category,
                                    sub_category: x.product.sub_category,
                                    product_code: x.product_code,
                                    product: x.product.name,
                                    sales_person: x.sales_person._id,
                                    uom: x.uom,
                                    target: x.target,
                                });
                            }
                            params = {
                                edit_data: editData,
                                new_product: newProd,
                            };
                        }
                    });
                } else {
                    this.tableData.sales.forEach(x => {
                        editData.push({
                            _id: x._id,
                            product_id: x.product._id,
                            category: x.product.category,
                            sub_category: x.product.sub_category,
                            product_code: x.product_code,
                            product: x.product.name,
                            sales_person: x.sales_person._id,
                            uom: x.uom,
                            target: x.target,
                        });
                    });
                    params = {
                        edit_data: editData,
                    };
                }
                params.edit_data.forEach(x => {
                    if (x.sales_person == null) {
                        delete x["sales_person"];
                    }
                });
                if ("new_product" in params) {
                    params.new_product.forecast.forEach(x => {
                        if (x.sales_person == null) {
                            delete x["sales_person"];
                        }
                    });
                }
                if (this.attachments.length) {
                    if (params.new_product) {
                        Object.assign(params.new_product, {
                            attachments: [],
                        });
                    } else {
                        Object.assign(params, {
                            new_product: newProd
                        });
                    }
                    this.attachments.forEach(x => {
                        params.new_product.attachments.push({
                            name: x.name,
                            size: x.size,
                            url: x.url,
                        });
                    });
                }
                try {
                    let res = await this.$http.post("sales_forecast/edit_forecast", params);
                    if (res.data.status_id == 1) {
                        // Success Response
                        this.$awn.success("Updated Successfully");
                        this.getDataToView();
                    }
                } catch (reason) {
                }
            },
            async getuom() {
                let params = {
                    search_key: "",
                    skip: 0,
                    limit: 10,
                };
                let res = await this.$http.post(
                    globals.SCM_API + "/fnb/scm/get_unit_of_measurements",
                    params
                );
                if (res.data.status_id == 1) {
                    if (res.data.unit_of_measurements) {
                        res.data.unit_of_measurements.forEach(x => {
                            this.uoms.push(x.name);
                        });
                    }
                } else {}
            },
            async searchUoms(key) {
                let params = {
                    search_key: this.search_key,
                    skip: 0,
                    limit: 10,
                };
                let res = await this.$http.post(
                    globals.SCM_API + "/fnb/scm/get_unit_of_measurements",
                    params
                );
                if (res.data.status_id == 1) {
                    if (res.data.unit_of_measurements) {
                        this.uoms = [];
                        res.data.unit_of_measurements.forEach(x => {
                            this.uoms.push(x.name);
                        });
                    }
                } else {}
            },
            async searchUomsAfter(reached) {
                if (reached) {
                    let params = {
                        search_key: this.search_key,
                        skip: this.uoms.length,
                        limit: 10,
                    };
                    let res = await this.$http.post(
                        globals.SCM_API + "/fnb/scm/get_unit_of_measurements",
                        params
                    );
                    if (res.data.status_id == 1) {
                        if (res.data.unit_of_measurements) {
                            res.data.unit_of_measurements.forEach(x => {
                                this.uoms.push(x.name);
                            });
                        }
                    } else {}
                };
            },
            async getProduts(key) {
                if (key) {
                    this.search_key = key;
                }
                let params = {
                    skip: 0,
                    limit: 10,
                    search: this.search_key,
                };
                let res = await this.$http.post(
                    globals.SCM_API + "/fnb/scm/get_product_listing_data",
                    params
                );
                if (res.data.status_id == 1) {
                    if (res.data.products) {
                        this.productoptions = [];
                        res.data.products.forEach(x => {
                            if ("name" in x) {
                                this.productoptions.push(x);
                            }
                        });
                    }
                }
            },
            async getProdutsAfter(reached) {
                if (reached) {
                    let params = {
                        skip: this.productoptions.length,
                        limit: 10,
                        search: this.search_key,
                    };
                    let res = await this.$http.post(
                        globals.SCM_API + "/fnb/scm/get_product_listing_data",
                        params
                    );
                    if (res.data.status_id == 1) {
                        if (res.data.products) {
                            res.data.products.forEach(x => {
                                if ("name" in x) {
                                    this.productoptions.push(x);
                                }
                            });
                        }
                    }
                };
            },
            clickedSelectAll() {
                this.selectAll = !this.selectAll;
                this.deleteIds = [];
                if (this.selectAll) {
                    this.tableData.sales.forEach((t, index) => {
                        this.deleteIds.push(t._id);
                    });
                    this.showEditDelete = true;
                } else {
                    this.showEditDelete = false;
                }
            },
            handleDeleteIds(id) {
                if (this.deleteIds.find(x => x === id)) {
                    this.deleteIds = this.deleteIds.filter(function (x) {
                        if (x !== id) {
                            return x;
                        }
                    });
                } else {
                    this.deleteIds.push(id);
                }
                if (this.deleteIds.length == this.tableData.sales.length) {
                    this.selectAll = true;
                    this.showEditDelete = true;
                    // this.activeSalesView = true;
                } else {
                    this.selectAll = false;
                    this.showEditDelete = false;
                    // this.activeSalesView = false;
                }
            },
            updateDept(branch) {
                this.departments = branch.departments;
            },
            async updateBranch(co) {
                try {
                    let params = {
                        company_name: co.company_name,
                    };
                    let res = await this.$http.post(
                        "shadow_companies/get_branches",
                        params
                    );
                    this.branchs = res.data.response;
                    if (!res.data.is_shadow) {
                        this.departments = this.branchs[0].departments;
                    }
                } catch (reason) {}
            },
            async getDataToView() {
                if (this.viewCompany) {
                    this.ajaxCallInProgress = true;
                    let res = await this.$http.get(
                        "sales_forecast/get?id=" + (this.viewCompanyUpdated ? this.viewCompanyUpdated : this
                            .viewCompany)
                    );
                    this.tableData = res.data.response;
                    this.tableData.sales.forEach(x => {
                        x.sales_person = {
                            _id: x.sales_person,
                            full_name: x.sales_person_name,
                        };
                        x.product = {
                            name: x.product,
                            product_code: x.product_code,
                            category: x.category || "",
                            sub_category: x.sub_category || "",
                            _id: x.product_id,
                        };
                    });
                    this.ajaxCallInProgress = false;
                    if (!this.documentTypeSelectedInside) {
                        this.selectCompany = this.tableData.company_name;
                        this.branchName = this.tableData.branch;
                        this.departmentName = this.tableData.department;
                        this.mainSalesPerson = this.tableData.main_sales_person;
                        this.target_year = this.tableData.target_year;
                        this.sales_number_id = this.tableData.sales_forecast_number
                        this.departments.push(this.tableData.department);
                        if (this.tableData.target_year) {
                            this.target_year_selected = this.tableData.target_year;
                        }
                    }
                    if (this.tableData.hasOwnProperty("attachments")) {
                        if (this.tableData.attachments) {
                            this.attachments = this.tableData.attachments;
                            this.images = [];
                            this.audiovideo = [];
                            this.files = [];
                            this.tableData.attachments.forEach(x => {
                                let type = x.name.split(".");
                                if (type[1] == "jpg" || type[1] == "jpeg" || type[1] == "png" || type[1] ==
                                    "svg") {
                                    this.images.push(x);
                                } else if (type[1] == "mpg" || type[1] == "mpeg" || type[1] == "mp4" ||
                                    type[1] == "mp3" || type[1] == "wav" || type[1] == "avi" || type[1] ==
                                    "webm") {
                                    this.audiovideo.push(x);
                                } else {
                                    this.files.push(x);
                                }
                            });
                        }
                    }
                    this.totalSaleForecast = res.data.count;
                    this.start = this.count * this.limit + 1;
                    let temp = this.count * this.limit + this.limit;
                    this.end = temp < this.totalSaleForecast ? temp : this.totalSaleForecast;
                    this.ajaxCallInProgress = false;
                    if (this.editCompany) {
                        this.tableData.sales.forEach(x => {
                            this.editIds.push(x._id);
                            this.deleteIds.push(x._id);
                        });
                        this.showEditDelete = true;
                    }
                    if (!this.documentTypeSelectedInside) {
                        if (this.tableData.document_type === "actual_sales") {
                            this.document_type = {
                                id: "actual_sales",
                                name: "Current Sales For Year",
                            }
                        } else if (this.tableData.document_type === "forecast") {
                            this.document_type = {
                                id: "forecast",
                                name: "Forecast for Year",
                            }
                        }
                    }
                }
            },
            clearData() {
                this.documentTypeSelectedInside = true;
                this.branchName = "";
                this.departmentName = "";
                this.getDataToView();
            },
            async fetchCustomers(key) {
                this.customers = [];
                if (key) {
                    this.search_key = key;
                };
                let response = await this.getCustomers({
                    skip: this.skip,
                    limit: this.limit,
                    search_key: this.search_key,
                });
                this.customers = response.response;
            },
            async reachedEndOfListCustomer(reached) {
                this.isVisible = reached;
                if (reached) {
                    if (this.scrollable == false) {
                        this.isLoading = true;
                        let res = await this.getCustomers({
                            skip: this.customers.length,
                            limit: this.limit,
                            search_key: this.search_key,
                        });
                        this.temp_customers = res.response.length;
                        if (res.skip == this.count) {
                            if (this.temp_customers > 0) {
                                let tempFiles = res.response;
                                tempFiles.forEach(el => {
                                    this.customers.push(el);
                                });
                                this.count += res.response.length;
                                this.isLoading = false;
                            } else {
                                this.scrollable = true;
                                this.isLoading = false;
                            }
                        }
                        this.isLoading = false;
                    }
                }
                // if (reached && this.customers.length >= 10) {
                //     if (this.scrollable == false) {
                //         this.isLoading = true;
                //         let res = await this.getCustomers({
                //             skip: this.customers.length,
                //             limit: this.limit,
                //             search_key: this.search_key,
                //         });
                //         res.response.forEach(x => {
                //             this.customers.push(x);
                //         });
                //         this.isLoading = false;
                //     }
                // }
            },
            createSaleForecast() {
                this.$router.push({
                    name: "CreateSalesForecast"
                });
            },
            handleClick() {},
            convertDate(str) {
                var month, day, year, hours, minutes, seconds;
                var date = new Date(str),
                    month = ("0" + (date.getMonth() + 1)).slice(-2),
                    day = ("0" + date.getDate()).slice(-2);
                hours = ("0" + date.getHours()).slice(-2);
                minutes = ("0" + date.getMinutes()).slice(-2);
                seconds = ("0" + date.getSeconds()).slice(-2);

                var mySQLDate = [date.getFullYear()].join("-");
                return [mySQLDate].join(" ");
            },
            getListSalesForecast() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.confirmSave();
                    }
                });
            },
            closeMultiselect() {
                this.skip = 0;
                this.search_key = "";
                this.show_multiselect = false;
            },
            async confirmSave() {
                this.ajaxCallInProgress = true;
                let params = {
                    filter_json: {
                        customer_id: [this.selectCompany._id],
                        branch: [this.branchName._id],
                        department: [this.departmentName],
                        main_sales_person: [this.mainSalesPerson._id],
                        target_year: this.target_year,
                        document_type: this.document_type.id,
                    },
                    skip: 0,
                    limit: 10,
                };
                let res = await this.$http.post("/sales_forecast/list", params);
                if (res.data.status_id == 1 && res.data.response.hasOwnProperty('sales') && res.data.response.sales
                    .length > 0) {
                    this.tableData = res.data.response;
                    if (this.tableData.sales.length > 0) {
                        this.tableData.sales.forEach(x => {
                            x.sales_person = {
                                _id: x.sales_person,
                                full_name: x.sales_person_name,
                            };
                            x.product = {
                                name: x.product,
                            };
                        });
                        this.viewCompanyUpdated = this.tableData.sales[0].sales_id;
                    }
                    this.totalSaleForecast = res.data.count;
                    this.start = this.count * this.limit + 1;
                    let temp = this.count * this.limit + this.limit;
                    this.end = temp < this.totalSaleForecast ? temp : this.totalSaleForecast;
                    this.ajaxCallInProgress = false;
                } else {
                    this.tableData.sales = [];
                }
                // this.getDataToView();
            },

            async deleteSales() {
                try {
                    let res = await this.$swal({
                        title: "Are you sure?",
                        text: "Are you sure to delete the Sales?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Yes",
                    });
                    if (res.value) {
                        this.deleteConfirmSales();
                    } else {
                        this.showEditDelete = false;
                        this.editIds = [];
                        this.deleteIds = [];
                    }
                } catch (error) {}
            },

            async deleteConfirmSales() {
                try {
                    let params = {
                        _id: this.deleteIds,
                    };
                    let res = await this.deleteSalesById(params);
                    this.$swal({
                        title: "Deleted",
                        text: "Sales Forecast Deleted Successfully.",
                        type: "success",
                        confirmButtonColor: "#005dae",
                    });
                    this.showEditDelete = false;
                    this.editIds = [];
                    this.deleteIds = [];
                    setTimeout(() => {
                        this.getListSalesForecast();
                    }, 500);
                    this.$router.push("/listsalesforecast");
                } catch (reason) {
                    this.$swal({
                        text: reason,
                        type: "warning",
                        confirmButtonText: "OK",
                        confirmButtonColor: "#005dae",
                    });
                }
            },
            formatPrice(value) {
                let val = (value / 1).toFixed(2).replace(",", ".");
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            },
            yearNext() {
                let year = this.years_to_set[5];
                this.years_to_set = [];
                for (let i = 0; i < 6; i++) {
                    this.years_to_set.push(year + i);
                }
            },
            yearPrev() {
                let year = this.years_to_set[0];
                this.years_to_set = [];
                for (let i = 0; i < 6; i++) {
                    this.years_to_set.push(year - i);
                }
                this.years_to_set.reverse();
            },
            yearClicked(startyear, endyear) {
                this.target_year_selected = startyear + "-" + endyear;
            },
            applyFiscalYear() {
                this.target_year = this.target_year_selected;
            },
            dropdownTriggered(event) {
                if (!event) {
                    this.selectedFilter = "";
                }
                if (event) {
                    this.hide_el_dropdown = false;
                }
            },
            getFilteredListData() {
                this.hide_el_dropdown = true;
                this.applyFiscalYear();
                this.getListSalesForecast();
            },
            updateProductCode(option, index) {
                this.tableData.sales[index].product_code = option.product_code;
            },
            async getListData() {
                this.ajaxCallInProgress = true;
                // if (this.productNames.length || this.productCode.length || this.salesPerson.length) {
                let params = {
                    filter_json: {
                        sales_id: [this.viewCompany],
                        product_name: [...new Set(this.productNames.map(x => x.name))],
                        product_code: [...new Set(this.productCode.map(x => x.product_code))],
                        sales_person: [...new Set(this.salesPerson.map(x => x._id))],
                    },
                    skip: 0,
                    limit: 10,
                };
                let res = await this.$http.post("/sales_forecast/list", params);
                this.tableData = res.data.response;
                // if(this.tableData){
                if (this.tableData.sales) {
                    this.tableData.sales.forEach(x => {
                        x.sales_person = {
                            _id: x.sales_person,
                            full_name: x.sales_person_name,
                        };
                        x.product = {
                            name: x.product,
                        };
                    });
                    this.departments.push(this.tableData.department);
                }
                // }else{
                //     this.tableData
                // }
                this.totalSaleForecast = res.data.count;
                this.start = this.count * this.limit + 1;
                let temp = this.count * this.limit + this.limit;
                this.end = temp < this.totalSaleForecast ? temp : this.totalSaleForecast;
                this.ajaxCallInProgress = false;
                if (this.editCompany) {
                    this.tableData.sales.forEach(x => {
                        this.editIds.push(x._id);
                        this.deleteIds.push(x._id);
                    });
                    this.showEditDelete = true;
                }
                // }
            },
            async fetchSalesPerson(key) {
                this.loadSalesPerson = true;
                if (key) {
                    this.search_key = key;
                }
                let params = {
                    search_key: this.search_key,
                    skip: this.skip,
                    limit: this.limit,
                    company_id: this.selectedCompany.company_id,
                    active_status: "active",
                };
                let res = await this.$http.post("employees/get_employees", params);
                if (res.data.status_id == 1) {
                    this.salesperson = [];
                    res.data.response.forEach(x => {
                        this.salesperson.push(x);
                    });
                    this.loadSalesPerson = false;
                }
            },
            async fetchSalesPersonAfter(reached) {
                if (reached) {
                    let search = "";
                    let params = {
                        search_key: this.search_key,
                        skip: this.salesperson.length,
                        limit: this.limit,
                        company_id: this.selectedCompany.company_id,
                        active_status: "active",
                    };
                    let res = await this.$http.post("employees/get_employees", params);
                    if (res.data.status_id == 1) {
                        res.data.response.forEach(x => {
                            this.salesperson.push(x);
                        });
                    }
                };
            },
        },
        created() {
            for (let i = 0; i < 6; i++) {
                let year = new Date().getFullYear();
                this.years_to_set.push(year + i);
            };
        },
        watch: {
            count() {
                this.confirmSave();
            },
        },
        computed: {
            selectedCompany() {
                return this.$store.getters.selectedCompany;
            },
            viewCompany() {
                return this.$store.getters.companyToView;
            },
            editCompany() {
                return this.$store.getters.companyToEdit;
            },
            getSkipCount(){
                if(this.total == 0) {
                    return 0
                } else {
                    let skip_count = this.skip>this.totalSaleForecast?this.totalSaleForecast:this.skip+1;
                    return skip_count;
                }
            },
        },
    };
</script>
<style scoped>
    .router {
        min-height: 34px;
        min-width: 35px !important;
        border-radius: 9px;
        background-color: grey;
    }

    .routers {
        max-height: 30px;
        min-width: 35px !important;
        border-radius: 6px !important;
        /* background-color: #005dae; */
    }

    .sales_overflow {
        overflow: auto !important;
    }

    .table.table-new-template thead tr th {
        vertical-align: sub !important;
    }

    .btn-xlg {
        border-radius: 2px;
    }

    .inputFieldTableSalesList {
        font-size: 14px !important;
        padding: 15.5px 10px 15px 2px !important;
        display: block;
        width: 100%;
        border: none;
        border-bottom: solid 0.6px #a9aaad !important;
        background: transparent !important;
        color: #303031;
        font-weight: 600;
        display: block;
        width: 100%;
        height: 34px;
        margin-top: 9px;
    }

    .inputFieldTableSalesList::placeholder {
        color: #7b7f83 !important;
        font-size: 13px;
        overflow: visible;
    }

    .table.table-scroll-listsales tbody td input.inputFieldTableSalesList:focus {
        border: 0px;
        border-bottom: solid 0.6px #00448b !important;
    }

    td span .inputFieldTableList {
        background-color: transparent !important;
        border-bottom: 1px solid #a9aaad;
    }

    td span span.invalid-feedback-form {
        position: absolute !important;
        margin-top: -0.1rem !important;
    }

    .whiteSpace {
        white-space: nowrap;
    }

    .fiscal-year-el.el-dropdown-menu {
        right: 20px !important;
        width: 200px;
    }

    .btn-table {
        border: dotted 1px #aaaaaa;
        background-color: rgba(214, 226, 239, 0.34);
        width: 100%;
        text-align: center;
        color: #303031;
        font-size: 14px;
        font-weight: 600;
        padding-top: 10px;
        padding-bottom: 10px;
        border-radius: 4px;
    }

    .btn-table:focus,
    .btn-table:active {
        outline: 0;
    }

    .head {
        background-color: #005dae;
    }

    @media (max-width: 1220px) {
        .responsiveHeader {
            flex-direction: column;
            align-items: flex-start !important;
            margin-top: 10px;
        }
    }

    @media (max-width: 510px) {
        #dateDiv {
            flex-direction: column;
        }
    }
    .view-sales-list{
        font-size: 14px;
        color: #000000;
        border-bottom: 1px solid #000;
        padding-bottom: 4px;
        margin-top:10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/ListSalesForecastFiltered.vue